import { EventEmitter2 } from 'eventemitter2';
import { LRUMap } from 'lru_map';
export const mediaState = {
  streams: new LRUMap(1000),
  stateDeferreds: new Map(),
  eventEmitter: new EventEmitter2()
};